import { Box, Typography, Grid } from '@mui/material';
import React from 'react';
import { DashboardAppConfig } from './DashboardAppConfig';
import { MediaCard } from '../../components/MediaCard';

const DashboardPage = (props) => {
    return (
        <>
            <Box sx={{ p: 5 }} alignItems="center">
                <Typography variant={'h2'}>Dashboards</Typography>
                <Grid container spacing={2} gridTemplateColumns={345} style={{ marginTop: 5 }}>
                    {Object.keys(DashboardAppConfig.pages).map(pageKey => {
                        const page = DashboardAppConfig.pages[pageKey];
                        return (
                            <Grid item sx={{ maxWidth: '500px' }} key={pageKey}>
                                <MediaCard
                                    key={pageKey}
                                    image={page.image}
                                    header={page.name}
                                    to={page.url}
                                    auth={page.auth} // Pass the auth attribute
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        </>
    );
};

export { DashboardPage };
